export default function filterLayoutToVisibleFromSchema(layout, schema) {
  if (!layout || !schema || !schema.properties) {
    return [];
  }
  return layout.reduce(function (acc, item) {
    var id = item.id,
      type = item.type;
    var properties = schema.properties;
    var property = properties[id];
    if (type === 'field' || type === 'array') {
      if (!!property && !property.__additional_property) {
        acc.push(item);
      }
    } else if (type === 'group') {
      var children = filterLayoutToVisibleFromSchema(item.children, schema);
      if (children.length > 0) {
        acc.push(Object.assign({}, item, {
          children: children
        }));
      }
    } else {
      acc.push(item);
    }
    return acc;
  }, []);
}